class AppSettingsService {
    GetWebApiBaseUri(): string {
        return process.env.REACT_APP_WEB_API_BASE_URI as string;
    }
}

export default AppSettingsService;